"use client";

import { DependencyList, EffectCallback, useEffect } from "react";
import { useMounted } from "@/hooks/useMounted";

/**
 * Drop-in replacement for useEffect for any effect that reads or manipulates
 * the DOM (observers, refs, window APIs). Guarantees the effect only runs
 * after the component is mounted on the client, preventing race conditions
 * with useMounted-guarded render trees.
 */
export function useClientEffect(
  effect: EffectCallback,
  deps: DependencyList = [],
) {
  const mounted = useMounted();
  useEffect(
    () => {
      if (!mounted) return;
      return effect();
    },
    // `deps` is the caller's dependency list, forwarded like useEffect's own.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mounted, ...deps],
  );
}
